// src/utils/appReport.js
// The installed Web App says it's in use (3.83.4, owner, Nov 4): each time it's
// opened or comes back to the front, for Analytics → Apps (backend
// lib/appUsage.js). Before this it only reported at sign-in and unlock, so Last
// used fell behind. A browser tab sends nothing. Who, which system and a random
// device id only.
import { API_BASE } from '../firebase/config';
import { isInstalledApp } from '../hooks/useInstallApp';

const QUIET_MS = 10 * 60000;   // the backend keeps one note per device in this time too
let lastSent = 0;
const DEVICE_ID = 'faxPortal.appDevice';

// A random id kept on this device, so each device is its own row (3.83.5)
function deviceId() {
  try {
    let id = localStorage.getItem(DEVICE_ID);
    if (!id) {
      id = Array.from(crypto.getRandomValues(new Uint8Array(12)), b => b.toString(16).padStart(2, '0')).join('');
      localStorage.setItem(DEVICE_ID, id);
    }
    return id;
  } catch { return null; }
}
// Safari on an iPad says it's a Mac; only the touch screen gives it away
const isIpad = () => navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;

// What the Web App says about itself, at sign-in and on each open
export const webAppClient = () => ({ app: 'web-app', installId: deviceId(), ...(isIpad() ? { system: 'ipad' } : {}) });

async function report(getToken) {
  if (!isInstalledApp() || Date.now() - lastSent < QUIET_MS) return;
  lastSent = Date.now();
  try {
    const token = await getToken();
    if (!token) { lastSent = 0; return; }
    await fetch(`${API_BASE}/portal/app-report`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
      body: JSON.stringify(webAppClient()),
    });
  } catch { lastSent = 0; }   // tried again next time it's opened
}

// Reports now and whenever the app shows again; returns the clean-up
export function watchWebApp(getToken) {
  const onShow = () => { if (document.visibilityState === 'visible') report(getToken); };
  onShow();
  document.addEventListener('visibilitychange', onShow);
  return () => document.removeEventListener('visibilitychange', onShow);
}
